export function toMSString( time:number ){
    let minutes = Math.floor( time / 60 );
    let seconds = Math.floor( time % 60 );
    return minutes + ':' + ( ( seconds < 10 ) ? ( '0' + seconds ) : seconds );
}